<ul>
  @for (item of navigationService.FEATURES; track item.title;) {
  <li>
    <app-navigation-item [navigationItem]="item"></app-navigation-item>
  </li>
  }
</ul>
<div class="divider"></div>
<ul>
  @for (item of navigationService.MAINTENANCE; track item.title;) {
  <li>
    <app-navigation-item [navigationItem]="item" (click)="item.title === 'support' ? openSupportModal() : null"></app-navigation-item>
  </li>
  }
</ul>
